<div class="container mt-1 mb">
    <div class="col-md-6 d-flex align-items-center mb-2" *ngIf="istrends">
        <div class="form-switch">
            <input class="form-check-input" type="checkbox" id="entryToggle" [checked]="isBulkEntry"
                (change)="onEntryTypeChange($event)" style="width: 3em; height: 1.5em;">
            <label class="form-check-label ms-2" for="entryToggle">
                {{ isBulkEntry ? 'Trends' : 'Main' }}
            </label>
        </div>
    </div>
    <div class="row d-flex" *ngIf="!isBulkEntry">
        <div class="row d-flex justify-content-between ">
            <div class="col-sm-12 col-lg-12  col-12  col-xl-12">
                <!-- <app-info-card-group></app-info-card-group> -->

                <div class="row">
                    <form id="fmc_master" [formGroup]="dashboardFilter"
                        (ngSubmit)="dashboardSubmit(dashboardFilter.value,'')">
                        <ul class="filterWrapper">
                            <li>
                                <div class="form-group three">
                                    <label class="form-label label-custom">GA Name</label>
                                    <ng-select class="custom" name="ga_code" [items]="GA" bindLabel="name_of_ga"
                                        bindValue="ga_code" formControlName="ga_code" placeholder="Select GA Name"
                                        (change)="getPlantCode($event)">
                                    </ng-select>
                                </div>
                            </li>
                            <li>
                                <div class="form-group three">
                                    <label class="form-label label-custom">SAP Plant Code</label>
                                    <ng-select [items]="PlantCodeDropDown" bindValue="plant_code"
                                        bindLabel="plant_code_concat" formControlName="plant_code"
                                        placeholder="Select Plant Code" [multiple]="true" [closeOnSelect]="false"
                                        [searchable]="true">
                                    </ng-select>

                                </div>
                            </li>
                            <!-- <li>
                        <div class="form-group">
                            <label  class="form-label label-custom">Plant Code</label>
                            <select class="form-select" >
                                <option selected>Plant Code</option>
                           
                            </select>
    
                        </div>
                    </li> -->
                            <li>
                                <div class="form-group">
                                    <label class="form-label label-custom ">From Date</label>
                                    <input formControlName="start_date" type="date" class="form-control" />
                                </div>
                            </li>
                            <li>
                                <div class="form-group">
                                    <label class="form-label label-custom ">To Date</label>
                                    <input formControlName="end_date" type="date" class="form-control"
                                        [max]="maxDate" />
                                </div>
                            </li>
                            <li>
                                <button [disabled]="!roleService.canModify('dashboard')" type="submit"
                                    class="btn btnsubmit-custom dashBtn8">Submit</button>
                            </li>
                        </ul>
                    </form>
                </div>

            </div>

        </div>
        <div class="row mt-2">
            <div class="col-12 col-sm-6 col-md-12 col-lg-4">
                <h5 class="title_chartdata">Sales During the Period</h5>
                <div class="piechartContainer">

                    <div class="card piechartBox">
                        <h5 class="title_chartdata peichartPosition">Amount in Lakh</h5>
                        <canvas baseChart id="pieChart3" height="150" width="150"></canvas>
                    </div>
                    <div class="total-text" style="margin-top: 5%;">Total: ₹ {{ number_of_cng_station | number:
                        '1.2-2':'en-IN' }} Lakh</div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-4">
                <h5 class="title_chartdata">Number of CNG Stations</h5>
                <div class="piechartContainer">
                    <div class="card piechartBox">
                        <canvas baseChart id="pieChart2"></canvas>
                    </div>
                    <div class="total-text" style="margin-top: 5%;">Total: {{ totalCNGStations }}</div>

                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-4">
                <h5 class="title_chartdata">Collection Mode</h5>
                <div class="piechartContainer">

                    <div class="card piechartBox">
                        <h5 class="title_chartdata peichartPosition">Amount in Lakh</h5>
                        <canvas baseChart id="pieChart1"></canvas>
                    </div>
                    <div class="total-text" style="margin-top: 5%;"> Total: ₹ {{ (totalCollectionMode) | number:'1.2-2'
                        }} Lakh
                    </div>

                </div>
            </div>
        </div>

        <div class="row mt-5">
            <div class="col-12">
                <h5 class="title_chartdata">Monthly Sales (GA-Wise)</h5>
                <div class="chartshow-data">
                    <h5 class="title_chartdata d-flex justify-content-end">Amount in Lakh</h5>
                    <div style="display: block; max-width:100%; margin: auto;">
                        <canvas id="myLineChart" height="100"></canvas>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row d-flex bgColor" *ngIf="isBulkEntry">
        <div class="row d-flex justify-content-between ">
            <div class="col-sm-12 col-lg-12  col-12  col-xl-12">
                <div class="row">
                    <!-- Info Cards Row -->
                    <app-info-card-group></app-info-card-group>

                    <div class="dashboard-toolbar d-flex align-items-center justify-content-between flex-wrap">
                        <h5 class="section-title">My Overview</h5>
                        <form [formGroup]="dashboardFilter" (ngSubmit)="dashboardTrendsSubmit(dashboardFilter.value)"
                            class="filter-form d-flex align-items-center gap-3 flex-wrap">

                            <!-- GA Name -->
                            <ng-select class="custom-ga-plant" name="ga_code" [items]="GA" bindLabel="name_of_ga"
                                bindValue="ga_code" formControlName="ga_code" placeholder="All GA"
                                (change)="getPlantCode($event)">
                            </ng-select>
                            <ng-select class="custom-ga-plant" [items]="PlantCodeDropDown" bindValue="plant_code"
                                bindLabel="plant_code_concat" formControlName="plant_code" placeholder="All Plant Code"
                                [multiple]="true" [closeOnSelect]="false" [searchable]="true">
                            </ng-select>

                            <!-- Preset Range Buttons -->
                            <div class="date-shortcuts d-flex align-items-center gap-2"
                                *ngIf="selectedRange !== 'CUSTOM'">
                                <button type="button" class="btn date-btn"
                                    [ngClass]="{'active': selectedRange === '7D'}"
                                    (click)="selectRange('7D')">7D</button>
                                <button type="button" class="btn date-btn"
                                    [ngClass]="{'active': selectedRange === '15D'}"
                                    (click)="selectRange('15D')">15D</button>
                                <button type="button" class="btn date-btn"
                                    [ngClass]="{'active': selectedRange === '30D'}"
                                    (click)="selectRange('30D')">30D</button>
                                <button type="button" class="btn date-btn"
                                    (click)="selectRange('CUSTOM')">Custom</button>
                            </div>
                            <div class="d-flex align-items-center gap-2" *ngIf="selectedRange === 'CUSTOM'">
                                <input type="date" class="form-control date-input custom-date-input thin-outline"
                                    formControlName="start_date"
                                    [max]="maxDate"
                                    (change)="limitCustomDateRange()" />
                                <span class="text-muted">to</span>
                                <input type="date" class="form-control date-input custom-date-input thin-outline"
                                    formControlName="end_date"
                                    [min]="dashboardFilter.value.start_date"
                                    [max]="customEndMaxDate"
                                    [disabled]="customEndDisabled" />
                                <button type="button" class="btn date-btn date-shortcuts" (click)="resetToDefault()"
                                    style="transition: background-color 0.3s; background-color: transparent;"
                                    onmouseover="this.style.backgroundColor='#f0ebeb';"
                                    onmouseout="this.style.backgroundColor='#f5f5f5';">
                                    Cancel
                                </button>
                            </div>
                            <style>
                                .custom-ga-plant {
                                    margin-bottom: -10px !important;
                                }

                                .custom-ga-plant .ng-select-container {
                                    min-height: 48px !important;
                                    min-width: 220px !important;
                                    font-size: 1rem;
                                }

                                .thin-outline {
                                    border-width: 1px !important;
                                    min-height: 40px !important;
                                    font-size: 1rem;
                                }
                            </style>
                            <!-- Submit -->
                            <button type="submit" class="btn-trend-submit d-flex align-items-center gap-2"
                                [disabled]="!roleService.canModify('dashboard')">
                                Submit
                                <svg width="20" height="12" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.175 13H4V11H16.175L10.575 5.4L12 4L20 12L12 20L10.575 18.6L16.175 13Z"
                                        fill="currentColor" />
                                </svg>
                            </button>


                        </form>
                    </div>



                    <app-chart-dashboard *ngIf="station?.length>0" [stationData]="station" [ownershipData]="ownership"
                        [movementData]="movement" [dashboardApplyFilter]="dashboardApplyFilter">
                    </app-chart-dashboard>
                </div>
            </div>
        </div>
    </div>
</div>